module.exports = __webpack_public_path__ + "static/media/cargill.d86eca9d.jpg";